import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';

import moment from 'moment';
import OkCancelModal from '@/shared/components/OkCancelModal';
import ResourceAutoComplete from '@/shared/components/registration/ResourceAutoComplete';
import { retrieveResources } from '@/shared/components/registration/resourceApi';
import Checkbox from '@/shared/components/input/Checkbox';
import CompoundDaysTimeInput from '@/shared/components/input/CompoundDaysTimeInput';
import messages from '../hrmMessages';

export default class BatchInitCounterModal extends Component {
  constructor(props) {
    super(props);
    const currentYear = moment.utc().year();
    this.state = {
      year: props.year || currentYear,
      resourceId: props.resourceId || null,
      startValueWholeDays: 0,
      startValueRemainderMinutes: 0,
      action: 0,
      overrideExisting: false,
      removeCorrections: true,
      years: [currentYear + 1, currentYear, currentYear - 1, currentYear - 2],
    };
  }

  static propTypes = {
    year: PropTypes.number,
    resourceId: PropTypes.string,
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  static defaultProps = {
    year: null,
    resourceId: null,
  };

  componentDidMount() {
    const { intl } = this.props;
    retrieveResources(intl, 3).then(data => {
      this.setState({
        resources: data
          .filter(x => {
            if (x.useCounter) return true;

            return x.isDefault && data.some(y => y.categoryId === x.categoryId && y.useCounter);
          })
          .map(x => ({ ...x, disabled: !!x.isDefault })),
      });
    });
  }
  onSave = () => {
    const { onSave } = this.props;
    const {
      year,
      resourceId,
      startValueWholeDays,
      startValueRemainderMinutes,
      overrideExisting,
      removeCorrections,
      action,
    } = this.state;
    if (this.isFormInvalid()) return Promise.reject();
    const model = {
      year,
      resourceId,
      overrideExisting,
      removeCorrections,
      startValueWholeDays: action === 0 ? startValueWholeDays : undefined,
      startValueRemainderMinutes: action === 0 ? startValueRemainderMinutes : undefined,
      fromPreviousYear: action === 1,
    };
    return Promise.resolve(onSave(model));
  };

  resourceFilterChanged = resource => {
    let resourceId = null;
    if (resource && !resource.isDefault) {
      resourceId = resource.id;
    }
    this.setState({ resourceId });
  };

  isFormInvalid = () => {
    const { year, resourceId, startValueWholeDays, startValueRemainderMinutes, action } = this.state;
    if (!year || year < 2000) return true;

    if (!resourceId) return true;
    if (action < 0 || action > 1) return true;
    if (action === 0 && (startValueWholeDays ?? 0) === 0 && (startValueRemainderMinutes ?? 0) === 0)
      return true;

    return false;
  };
  render() {
    const { show, intl, onClose } = this.props;
    const {
      year,
      resourceId,
      startValueWholeDays,
      startValueRemainderMinutes,
      overrideExisting,
      removeCorrections,
      years,
      resources,
      action,
    } = this.state;
    if (!show) return null;

    const selectedResource =
      resourceId && resources ? resources.find(x => x.id === resourceId) : null;
    return (
      <OkCancelModal
        title={intl.formatMessage(messages.InitializeCounter)}
        show={show}
        onClose={onClose}
        disabled={this.isFormInvalid()}
        onSave={this.onSave}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <label className="control-label col-sm-3">{intl.formatMessage(messages.Year)}</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                id="year"
                value={year || ''}
                onChange={e => this.setState({ year: parseInt(e.target.value) })}
              >
                {years.map(y => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-3">
              {intl.formatMessage(messages.Resource)}
            </label>
            <div className="col-sm-8">
              <ResourceAutoComplete
                id="resource"
                items={resources}
                onChange={this.resourceFilterChanged}
                value={selectedResource}
                placeholder={intl.formatMessage(messages.Resource)}
                intl={intl}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="control-label col-sm-3">{intl.formatMessage(messages.Action)}</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                id="action"
                value={action}
                onChange={e => this.setState({ action: parseInt(e.target.value) })}
              >
                <option value={0}>{intl.formatMessage(messages.SetStartValue)}</option>
                <option value={1}>{intl.formatMessage(messages.CopyFromPreviousYear)}</option>
              </select>
            </div>
          </div>
          {action === 0 && (
            <div className="form-group">
              <label className="control-label col-sm-3">
                {intl.formatMessage(messages.AbsenceStartValue)}
              </label>
              <div className="col-sm-8">
                <CompoundDaysTimeInput
                  id="startValue"
                  wholeDays={startValueWholeDays}
                  remainderMinutes={startValueRemainderMinutes}
                  onChange={({ wholeDays, remainderMinutes }) =>
                    this.setState({
                      startValueWholeDays: wholeDays,
                      startValueRemainderMinutes: remainderMinutes,
                    })
                  }
                />
              </div>
            </div>
          )}
          <div className="form-group">
            <Checkbox
              extraClass="col-sm-offset-3 col-md-8"
              id="overrideExisting"
              value={overrideExisting}
              onClick={() => this.setState({ overrideExisting: !overrideExisting })}
              text={intl.formatMessage(messages.OverrideIfCounterAlreadyExists)}
            />
          </div>
          <div className="form-group">
            <Checkbox
              extraClass="col-sm-offset-3 col-md-8"
              id="removeCorrections"
              value={removeCorrections}
              onClick={() => this.setState({ removeCorrections: !removeCorrections })}
              text={intl.formatMessage(messages.RemoveExistingCorrections)}
            />
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
